<ng-container *ngIf="landing">
  <div class="sticky-top">
    <div class="referral-bar p-3" *ngIf="referralData">
      <div class="d-flex justify-content-center align-items-center">
        <span class="ico-hi">👋</span>
        <div class="item text-left">
          <p class="text-primary mb-0"><span class="text-bold">{{referralData.name}}</span> {{ 'LANDING.landing.refText1' | translate }}</p>
          <p class="text-secondary text-small mb-0">{{ 'LANDING.landing.refText2' | translate }}</p> 
        </div>
      </div>
    </div>
    <header class="navbar navigation">
      <div class="d-flex align-items-center">
        <span class="logo clickable" routerLink="/"></span>
        <ul class="navlinks d-flex align-items-center ml-4 desktop-only">
          <li class="pages">
            <a *ifLanguage="'pt'" [routerLink]="'/agenda'">{{ 'LANDING.nav.calendar' | translate }}</a>
            <a *ifLanguage="'!pt'" [routerLink]="'/calendar'">{{ 'LANDING.nav.calendar' | translate }}</a>
          </li>
          <li class="pages">
            <a *ifLanguage="'pt'" [routerLink]="'/pagina-marcacoes'">{{ 'LANDING.nav.bookingPage' | translate }}</a>
            <a *ifLanguage="'!pt'" [routerLink]="'/booking-page'">{{ 'LANDING.nav.bookingPage' | translate }}</a>
          </li>
          <li>
            <a [routerLink]="[]" fragment="pricing" (click)="analyticsEvent('navbar-pricing')">{{ 'LANDING.nav.pricing' | translate }}</a>
          </li>
        </ul>
      </div>
      <ul class="navlinks d-flex align-items-center">
        <li class="desktop-only" *ngIf="salesPhone">
          <a (click)="analyticsEvent('navbar-phone')" class="btn btn-md btn-secondary d-flex align-items-center"
          href="tel:{{salesPhone}}"><i class="material-icons ico mr-1">call</i>{{salesPhone}}</a
          >
        </li>
        <li>
          <button (click)="analyticsEvent('navbar-login')" class="btn btn-md btn-secondary" routerLink="/login">{{ landing.login }}</button>
        </li>
        <li>
          <button (click)="analyticsEvent('navbar-signup')" class="btn btn-md btn-primary desktop-only" routerLink="/signup">
            {{ 'LANDING.landing.registerCta' | translate }}
          </button>
          <button (click)="analyticsEvent('navbar-signup')" class="btn btn-md btn-primary mobile-only" routerLink="/signup">
            {{ 'LANDING.landing.registerCta2' | translate }}
          </button>
        </li>
        <li class="mobile-only">
          <span class="material-icons ico-mobile-menu text-primary" (click)="toggleMobileNav()">menu</span>
        </li>
        <li class="desktop-only">
          <app-language-picker />
        </li>
      </ul>
    </header> 
  </div>

  <div *ngIf="promoBannerActive" class="newPromo">
    <a routerLink="/signup">
      <img class="promo-img cursor-pointer" src="https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fimg-blackfriday-2.png?alt=media" alt="">
    </a>
  </div>

  <!-- GeoLanding banner -->
  <div *ngIf="locationTargetedData" class="geoPromo" style="background-image: url({{locationTargetedData.image}});">
    <a routerLink="/signup">
      <h1>{{locationTargetedData.title}}</h1>
      <p class="mb-0">Plan PRO 50% con el código: <strong>{{locationTargetedData.code}}</strong></p>
    </a>
  </div>

  <!-- <div class="fixed-video" (click)="showVideoOverlay()" data-nosnippet>
    <i class="material-icons icon">play_circle_filled</i> Veja como começar <span class="time">(1m32s)</span>
  </div> -->
  <app-google-auth [showPrompt]="true" type="signup"></app-google-auth>

  <div class="overlay-videos" *ngIf="showVideo">
    <i class="material-icons icon" (click)="showVideoOverlay()">close</i>
    <div class="container">
      <div class="row d-flex justify-content-center align-items-center vh-100">
        <div class="col-12">
          <div class="video-container">
            <div *ifLanguage="'pt'">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/XxdAGgtGYLM?autoplay=1"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
            <div *ifLanguage="'en'">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/MkAiKBbXP_Q?autoplay=1"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
            <div *ifLanguage="'es'">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/PIBn-MFlpsw?autoplay=1"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mobile-nav-overlay" (click)="toggleMobileNav()" *ngIf="showMobileNav"></div>
  <div class="mobile-nav" [ngClass]="{ navAnim: showMobileNav }">
    <div class="container">
      <div class="row">
        <div class="col">
          <i class="material-icons icon" (click)="toggleMobileNav()">close</i>
          <ul>
            <li>
              <a *ifLanguage="'!pt'" [routerLink]="'/calendar'">{{ 'LANDING.nav.calendar' | translate }}</a>
              <a *ifLanguage="'pt'" [routerLink]="'/agenda'">{{ 'LANDING.nav.calendar' | translate }}</a>
            </li>
            <li>
              <a *ifLanguage="'!pt'" [routerLink]="'/booking-page'">{{ 'LANDING.nav.bookingPage' | translate }}</a>
              <a *ifLanguage="'pt'" [routerLink]="'/pagina-marcacoes'">{{ 'LANDING.nav.bookingPage' | translate }}</a>
            </li>
            <li>
              <a [routerLink]="[]" fragment="pricing" (click)="toggleMobileNav(); analyticsEvent('navbar-pricing')">{{ 'LANDING.nav.pricing' | translate }}</a>
            </li>
            <li>
              <a routerLink="/faqs">{{ 'LANDING.landing.faqs' | translate }}</a>
            </li>
            <li>
              <app-language-picker />
            </li>
          </ul>
          <div class="d-flex flex-column justify-content-center mb-3 mobile-only">
            <a
              *ngIf="salesPhone"
              (click)="analyticsEvent('navbar-phone')"
              class="btn btn-lg btn-secondary d-flex align-items-center mb-3"
              href="tel:{{salesPhone}}"
              ><i class="material-icons ico mr-1">call</i>{{salesPhone}}</a
            >
            <button (click)="analyticsEvent('navbar-signup')" class="btn btn-lg btn-primary" routerLink="/signup">
              {{ landing.registerCta }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- GeoLanding class .hero-geocorrect / switch to .hero-correct-->
  <section class="hero-2 bg-blue" [class.hero-geocorrect]="locationTargetedData || promoBannerActive"
  [class.hero-correct]="!locationTargetedData && !promoBannerActive">

    <div class="container-fluid">
      <div class="row align-items-center flex-md-row-reverse">
        <div class="col-md-6 mb-4">
          <img
            responsiveImg
            url="{{ landing.heroImg }}"
            fetchpriority="high"
            mobileWidth="600"
            desktopWidth="1100"
            data-nosnippet
            nolazy
            alt=""
            class="nl-1"
            (click)="showVideoOverlay()"
          />
        </div>
        <div class="col-md-6 mb-4">
          <h1 class="h1-2 mb-4">{{ 'LANDING.landing.pageTitle' | translate }}</h1>
          <p class="large mb-4">{{ 'LANDING.landing.pageDescription' | translate }}</p>
          <div class="d-flex justify-content-start mb-3 desktop-only">
            <button (click)="analyticsEvent('landing-hero-signup')" class="btn btn-lg btn-secondary mr-3" routerLink="/signup">
              {{ landing.registerCta }}
            </button>
            <a
              (click)="analyticsEvent('landing-hero-demo')"
              class="btn btn-lg btn-secondary-outline"
              target="_blank"
              [href]="toolsService.getDemoLink()"
              >{{ landing.contactCta }}</a
            >
          </div>
          <div class="d-flex flex-column justify-content-center mb-3 mobile-only">
            <button (click)="analyticsEvent('landing-hero-signup')" class="btn btn-lg btn-secondary mb-3" routerLink="/signup">
              {{ landing.registerCta }}
            </button>
            <a
              (click)="analyticsEvent('landing-hero-demo')"
              class="btn btn-lg btn-secondary-outline mb-3"
              target="_blank"
              [href]="toolsService.getDemoLink()"
              >{{ landing.contactCta }}</a
            >
          </div>
          <a routerLink="/signup" *ifCountry="'pt'">
            <p class="pro-code text-white small mb-5">
              ⚡️ {{ 'LANDING.landing.promoCopy' | translate }}
            </p>
          </a>
          <a routerLink="/signup" *ifCountry="'es'">
            <p class="pro-code text-white small mb-5">
              ⚡️ {{ 'LANDING.pricing.tryPro' | translate }}
            </p>
          </a>
        </div>
      </div>
    </div>
  </section>

  


  <section class="bg-2 n-section">
    <div class="container-fluid">
      <div class="row mb-4">
        <div class="col-md-3 text-center mb-2">
          <h2 class="h2-2 text-primary mb-0">{{ 'LANDING.landing.stats.title1' | translate }}</h2>
          <p class="text-primary">{{ 'LANDING.landing.stats.text1' | translate }}</p>
        </div>
        <div class="col-md-3 text-center mb-2">
          <h2 class="h2-2 text-primary mb-0">{{ 'LANDING.landing.stats.title2' | translate }}</h2>
          <p class="text-primary">{{ 'LANDING.landing.stats.text2' | translate }}</p>
        </div>
        <div class="col-md-3 text-center mb-2">
          <h2 class="h2-2 text-primary mb-0">{{ 'LANDING.landing.stats.title3' | translate }}</h2>
          <p class="text-primary">{{ 'LANDING.landing.stats.text3' | translate }}</p>
        </div>
        <div class="col-md-3 text-center mb-2">
          <h2 class="h2-2 text-primary mb-0">{{ 'LANDING.landing.stats.title4' | translate }}</h2>
          <p class="text-primary">{{ 'LANDING.landing.stats.text4' | translate }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <div class="d-flex align-items-center justify-content-center nl-logos">
            <img src="assets/partners-google.png" class="nl-partners-logos" />
            <a *ifCountry="'pt'"
              href="https://observador.pt/2020/11/26/buk-a-plataforma-portuguesa-que-quer-facilitar-a-marcacao-de-servicos-online/"
              target="_blank">
              <img responsiveImg url="nl-press.jpg" mobileWidth="350" desktopWidth="1200" class="nl-press" />
            </a>
            <a *ifCountry="'es'"
              href="https://canaldemadrid.com/llega-a-espana-buk-el-software-de-gestion-de-citas-para-simplificar-el-proceso-de-reservas/"
              target="_blank">
              <img responsiveImg url="nl-press.jpg" mobileWidth="350" desktopWidth="1200" class="nl-press" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="d-flex how-to">
    <div class="bg-blue-dark text-center section">
      <span class="pill-feat mb-3 bg-blue">{{ 'LANDING.landing.how-to.pill1' | translate }}</span>
      <h2 class="h2-2">{{ 'LANDING.landing.how-to.title1' | translate }}</h2>
      <p class="large mb-4">{{ 'LANDING.landing.how-to.text1' | translate }}</p>
      <img responsiveImg url="calendar-geral.png" mobileWidth="300" desktopWidth="656" alt="" class="how-to-1" />
    </div>
    <div class="bg-blue text-center section">
      <span class="pill-feat mb-3 bg-blue-dark">{{ 'LANDING.landing.how-to.pill2' | translate }}</span>
      <h2 class="h2-2" [innerHtml]="'LANDING.landing.how-to.title2' | translate"></h2>
      <p class="large mb-4" [innerHtml]="'LANDING.landing.how-to.text2' | translate"></p>
      <img responsiveImg url="{{ landing.appImg }}" mobileWidth="300" desktopWidth="656" alt="" class="how-to-1" />
    </div>
  </section>

  <section class="bg-blue features-2 n-section">
    <div class="container-fluid">
      <div class="row">
        <div class="col text-center">
          <h1 class="h1-2 mb-5" [innerHtml]="landing.featuresTitle"></h1>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="features-wrapper mb-5">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-4 mb-3" *ngFor="let feature of landing.features">
                  <div class="feature-box">
                    <span class="ico-feature {{ feature.icon }}"></span>
                    <p class="text-bold mb-1">{{ feature.title }}</p>
                    <p class="text-gray">{{ feature.text }}</p>
                    <!-- <img src="assets/nl-payments.png" alt="">
                    <img src="assets/nl-google.png" alt=""> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <div class="d-flex justify-content-center mb-3 desktop-only">
            <button (click)="analyticsEvent('landing-features-signup')" class="btn btn-lg btn-secondary mr-3" routerLink="/signup">
              {{ landing.registerCta }}
            </button>
            <a
              (click)="analyticsEvent('landing-features-demo')"
              class="btn btn-lg btn-secondary-outline"
              target="_blank"
              [href]="toolsService.getDemoLink()"
              >{{ landing.contactCta }}</a
            >
          </div>
          <div class="d-flex flex-column justify-content-center mb-3 mobile-only">
            <button (click)="analyticsEvent('landing-features-signup')" class="btn btn-lg btn-secondary mb-3" routerLink="/signup">
              {{ landing.registerCta }}
            </button>
            <a
              (click)="analyticsEvent('landing-features-demo')"
              class="btn btn-lg btn-secondary-outline mb-3"
              target="_blank"
              [href]="toolsService.getDemoLink()"
              >{{ landing.contactCta }}</a
            >
          </div>
          <a routerLink="/signup" *ifCountry="'pt'">
            <p class="pro-code text-white small mb-5">
              ⚡️ {{ 'LANDING.landing.promoCopy' | translate }}
            </p>
          </a>
          <a routerLink="/signup" *ifCountry="'es'">
            <p class="pro-code text-white small mb-5">
              ⚡️ {{ 'LANDING.pricing.tryPro' | translate }}
            </p>
          </a>
        </div>
      </div>
    </div>
  </section>

  <section class="bg-2 text-center n-section" *ifLanguage="'!pt'">
    <div class="container">
      <div class="row">
        <div class="col">
          <h1 class="h1-2 mt-5 mb-5">{{ landing.testimoniesTitle }}</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 mb-4" *ngFor="let testemony of landing.testemonies">
          <div class="ballon mb-3">
            <p class="mb-0">"{{ testemony.text }}"</p>
          </div>
          <div class="client-review">
            <img src="{{ testemony.image }}" alt="" />
            <p class="mb-0 text-bold">{{ testemony.person }}</p>
            <p class="mb-0 text-gray">{{ testemony.buisiness }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="bg-2 text-center n-section" *ifLanguage="'pt'">
    <div class="container-fluid p-0">
      <div class="row">
        <div class="col">
          <h1 class="h1-2 mt-5 mb-5 x-3">{{ landing.testimoniesTitle }}</h1>
        </div>
      </div>
      <div class="reviews-slider-container">
        <div class="reviews-slider py-4">
          <a class="mx-2" routerLink="/signup"><img src="https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fig-google-reviews%202.jpg?alt=media&optimized=true" alt="Google Review" class="review-image" loading="lazy" decoding="async"></a>
          <a class="mx-2" routerLink="/signup"><img src="https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fig-google-reviews%208.jpg?alt=media&optimized=true" alt="Google Review" class="review-image" loading="lazy" decoding="async"></a>
          <a class="mx-2" routerLink="/signup"><img src="https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fig-google-reviews%203.jpg?alt=media&optimized=true" alt="Google Review" class="review-image" loading="lazy" decoding="async"></a>
          <a class="mx-2" routerLink="/signup"><img src="https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fig-google-reviews%204.jpg?alt=media&optimized=true" alt="Google Review" class="review-image" loading="lazy" decoding="async"></a>
          <a class="mx-2" routerLink="/signup"><img src="https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fig-google-reviews%201-1.jpg?alt=media&optimized=true" alt="Google Review" class="review-image" loading="lazy" decoding="async"></a>
          <a class="mx-2" routerLink="/signup"><img src="https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fig-google-reviews%205.jpg?alt=media&optimized=true" alt="Google Review" class="review-image" loading="lazy" decoding="async"></a>
          <a class="mx-2" routerLink="/signup"><img src="https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fig-google-reviews%207.jpg?alt=media&optimized=true" alt="Google Review" class="review-image" loading="lazy" decoding="async"></a>
          <a class="mx-2" routerLink="/signup"><img src="https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fig-google-reviews%206.jpg?alt=media&optimized=true" alt="Google Review" class="review-image" loading="lazy" decoding="async"></a>
          <!-- Duplicate images for continuous loop effect -->
          <a class="mx-2" routerLink="/signup"><img src="https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fig-google-reviews%202.jpg?alt=media&optimized=true" alt="Google Review" class="review-image" loading="lazy" decoding="async"></a>
          <a class="mx-2" routerLink="/signup"><img src="https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fig-google-reviews%208.jpg?alt=media&optimized=true" alt="Google Review" class="review-image" loading="lazy" decoding="async"></a>
          <a class="mx-2" routerLink="/signup"><img src="https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fig-google-reviews%203.jpg?alt=media&optimized=true" alt="Google Review" class="review-image" loading="lazy" decoding="async"></a>
          <a class="mx-2" routerLink="/signup"><img src="https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fig-google-reviews%204.jpg?alt=media&optimized=true" alt="Google Review" class="review-image" loading="lazy" decoding="async"></a>
          <a class="mx-2" routerLink="/signup"><img src="https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fig-google-reviews%201-1.jpg?alt=media&optimized=true" alt="Google Review" class="review-image" loading="lazy" decoding="async"></a>
          <a class="mx-2" routerLink="/signup"><img src="https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fig-google-reviews%205.jpg?alt=media&optimized=true" alt="Google Review" class="review-image" loading="lazy" decoding="async"></a>
          <a class="mx-2" routerLink="/signup"><img src="https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fig-google-reviews%207.jpg?alt=media&optimized=true" alt="Google Review" class="review-image" loading="lazy" decoding="async"></a>
          <a class="mx-2" routerLink="/signup"><img src="https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fig-google-reviews%206.jpg?alt=media&optimized=true" alt="Google Review" class="review-image" loading="lazy" decoding="async"></a>
        </div>
      </div>
    </div>
  </section>  

  <section class="n-section" id="pricing">
    <app-pricing [ref]="referralData" [promoBannerActive]="promoBannerActive"></app-pricing>
  </section>

<section class="n-section bg-2 text-center section-carousel" *ngIf="landing.businesses?.length">
    <h2 class="h2-2 mb-5">{{ 'LANDING.landing.everyBusiness' | translate }}</h2>
    <div class="carousel">
      <a
        routerLink="{{ buisiness.urls[language] }}"
        *ngFor="let buisiness of landing.businesses"
        class="box-business block"
        rel="canonical"
        style="background-image: url('/assets/{{ buisiness.class }}.jpg');"
      >
        <h3 class="mb-0">{{ buisiness.text }}</h3>
      </a>
    </div>
  </section>
  <section class="bg-blue n-section">
    <div class="container-fluid">
      <div class="row">
        <div class="col text-center">
          <h1 class="h1-2 mb-5">{{ 'LANDING.landing.help' | translate }} 🙋</h1>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-6">
          <accordion [closeOthers]="true">
            <accordion-group heading="{{ 'LANDING.faqs.q1' | translate }}">
              <div [innerHTML]="'LANDING.faqs.a1' | translate"></div>
            </accordion-group>
            <accordion-group heading="{{ 'LANDING.faqs.q2' | translate }}">
              <div [innerHTML]="'LANDING.faqs.a2' | translate"></div>
            </accordion-group>
            <accordion-group heading="{{ 'LANDING.faqs.q5b' | translate }} {{ landing.buisiness?.toLowerCase() }}?">
              <div [innerHTML]="'LANDING.faqs.a5' | translate"></div>
            </accordion-group>
            <accordion-group heading="{{ 'LANDING.faqs.q11' | translate }}">
              <div [innerHTML]="'LANDING.faqs.a11' | translate"></div>
            </accordion-group>
          </accordion>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col text-center">
          <button class="btn btn-lg btn-secondary mr-3" routerLink="/faqs">
            <a routerLink="/faqs">{{ 'LANDING.landing.featuresPanel8.text' | translate }} →</a>
          </button>
        </div>
      </div>
    </div>
  </section>

  <section class="bg-blue-dark n-section">
    <div class="container pt-5 pb-5">
      <div class="row justify-content-center text-center">
        <div class="col-md-8">
          <h1 class="h1-2 mb-5">{{ 'LANDING.landing.ctaSection.title' | translate }}</h1>
          <p class="large mb-5">{{ 'LANDING.landing.ctaSection.text' | translate }}</p>
          <div class="d-flex justify-content-center mb-3 desktop-only">
            <button (click)="analyticsEvent('landing-CTAsection-signup')" class="btn btn-lg btn-secondary mr-3" routerLink="/signup">
              {{ landing.registerCta }}
            </button>
            <a
              (click)="analyticsEvent('landing-CTAsection-demo')"
              class="btn btn-lg btn-secondary-outline"
              target="_blank"
              [href]="toolsService.getDemoLink()"
              >{{ landing.contactCta }}</a
            >
          </div>
          <div class="d-flex flex-column justify-content-center mb-3 mobile-only">
            <button (click)="analyticsEvent('landing-CTAsection-signup')" class="btn btn-lg btn-secondary mb-3" routerLink="/signup">
              {{ landing.registerCta }}
            </button>
            <a
              (click)="analyticsEvent('landing-CTAsection-demo')"
              class="btn btn-lg btn-secondary-outline mb-3"
              target="_blank"
              [href]="toolsService.getDemoLink()"
              >{{ landing.contactCta }}</a
            >
          </div>
          <a routerLink="/signup" *ifCountry="'pt'">
            <p class="pro-code text-white small mb-5">
              ⚡️ {{ 'LANDING.landing.promoCopy' | translate }}
            </p>
          </a>
          <a routerLink="/signup" *ifCountry="'es'">
            <p class="pro-code text-white small mb-5">
              ⚡️ {{ 'LANDING.pricing.tryPro' | translate }}
            </p>
          </a>
        </div>
      </div>
    </div>
  </section>

  <section class="bg-2 blog n-section" *ifLanguage="'pt'">
    <div class="container-fluid">
      <div class="row">
        <div class="col text-center">
          <h1 class="h1-2 text-primary mt-5 mb-5">{{ 'LANDING.landing.blog' | translate }} 💬</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <a href="https://blog.buk.pt/5-dicas-para-promover-o-seu-negocio-online/" target="_blank">
            <div class="blog-post">
              <div
                class="thumb mb-3"
                style="
                  background-image: url(https://blog.buk.pt/content/images/size/w2000/2022/04/5-dicas-para-promover-o-seu-neg-cio-online-1.jpg);
                "
              ></div>
              <h3 class="h3">5 Dicas para promover o seu negócio online</h3>
              <p class="text-gray small">Promova o seu negócio online e conquiste os seus clientes.</p>
              <span>Ler artigo</span>
            </div>
          </a>
        </div>
        <div class="col-md-4">
          <a href="https://blog.buk.pt/7-dicas-para-fidelizar-clientes-no-salao-de-beleza/" target="_blank">
            <div class="blog-post">
              <div
                class="thumb mb-3"
                style="
                  background-image: url(https://blog.buk.pt/content/images/size/w1000/2021/11/hannah-busing-Zyx1bK9mqmA-unsplash-1.jpg);
                "
              ></div>
              <h3 class="h3">7 dicas para fidelizar clientes no sector da beleza e estética</h3>
              <p class="text-gray small">
                Com o crescimento exponencial do sector, existem dezenas de novos estabelecimentos a abrir diariamente, a área da beleza e
                bem-estar cresce a cada ano e a concorrência não é pouca.
              </p>
              <span>Ler artigo</span>
            </div>
          </a>
        </div>
        <div class="col-md-4">
          <a href="https://blog.buk.pt/colocar-link-redes-sociais/" target="_blank">
            <div class="blog-post">
              <div
                class="thumb mb-3"
                style="background-image: url(https://blog.buk.pt/content/images/size/w1000/2020/12/buk-redes-sociais-1.jpeg)"
              ></div>
              <h3 class="h3">Onde colocar o link para a sua Página de Marcações BUK</h3>
              <p class="text-gray small">
                Já configurou a sua Agenda, já personalizou a sua Página de Marcações e o seu link BUK. E agora?
              </p>
              <span>Ler mais</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>

  <section class="footer n-section bg-2">
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <div class="footer-wrap">
            <div class="row mb-4">
              <div class="col-md-3 mb-4">
                <span class="logo mb-2"></span>
                <p>{{ 'LANDING.landing.reachOut' | translate }} <a href="mailto:{{supportEmail}}">{{supportEmail}}</a></p>
              </div>
              <div class="col-md-3 mb-4">
                <ul>
                  <li>
                    <a *ifLanguage="'!pt'" rel="canonical" [routerLink]="'/calendar'">{{ 'LANDING.nav.calendar' | translate }}</a>
                    <a *ifLanguage="'pt'" rel="canonical" [routerLink]="'/agenda'">{{ 'LANDING.nav.calendar' | translate }}</a>
                  </li>
                  <li>
                    <a *ifLanguage="'!pt'" rel="canonical" [routerLink]="'/booking-page'">{{ 'LANDING.nav.bookingPage' | translate }}</a>
                    <a *ifLanguage="'pt'" rel="canonical" [routerLink]="'/pagina-marcacoes'">{{ 'LANDING.nav.bookingPage' | translate }}</a>                  </li>
                  <li>
                    <a [routerLink]="[]" fragment="pricing" (click)="analyticsEvent('navbar-pricing')">{{ 'LANDING.nav.pricing' | translate }}</a>
                  </li>
                  <li>
                    <a rel="canonical" routerLink="/faqs">{{ 'LANDING.landing.faqs' | translate }}</a>
                  </li>
                  <li class="open-help-modal">
                    <a (click)="showHelpModal()">{{ 'LANDING.landing.help' | translate }}</a>
                  </li>
                  <li>
                    <a [href]="'https://blog.' + host">{{ 'LANDING.landing.blog' | translate }}</a>
                  </li>
                </ul>
              </div>
              <div class="col-md-3 mb-4">
                <ul>
                  <li>
                    <a target="_blank" rel="canonical" routerLink="/terms">{{ 'LANDING.landing.terms' | translate }}</a>
                  </li>
                  <li>
                    <a target="_blank" rel="canonical" routerLink="/privacy">{{ 'LANDING.landing.privacy' | translate }}</a>
                  </li>
                  <li>
                    <a target="_blank" rel="canonical" routerLink="/cookie-policy">{{ 'LANDING.landing.cookies' | translate }}</a>
                  </li>
                </ul>
              </div>
              <div class="col-md-3 mb-4">
                <ul>
                  <li>
                    <div class="d-flex socials">
                      <a target="_blank" *ifCountry="'pt'"href="https://www.facebook.com/bukapp"><img src="assets/svg-fb.svg" alt="" /></a>
                      <a target="_blank" *ifCountry="'es'" href="https://www.facebook.com/bukespana"><img src="assets/svg-fb.svg" alt="" /></a>
                      <a target="_blank" *ifCountry="'pt'" href="https://www.instagram.com/buk.pt"><img src="assets/svg-ig.svg" alt="" /></a>
                      <a target="_blank" *ifCountry="'us'" href="https://www.instagram.com/buk.app"><img src="assets/svg-ig.svg" alt="" /></a>
                      <a target="_blank" *ifCountry="'es'" href="https://www.instagram.com/buk.espana"><img src="assets/svg-ig.svg" alt="" /></a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="row">
              <div class="col text-center">
                <p class="mb-1 small">
                  {{ 'LANDING.landing.footerText1' | translate }} <a target="_blank" href="https://uvstudio.co">uvstudio.co</a> ∙
                  {{ 'LANDING.landing.footerText2' | translate }}
                </p>
                <p *ifCountry="'pt'" class="mb-0 small"><a target="_blank" href="https://www.livroreclamacoes.pt/Inicio/">Livro de reclamações</a> ∙ R. Casimiro Freire 9A, 1900-268 Lisboa</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="seo n-section">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-3" *ngFor="let group of landing.businessesFooter">
          <h3 class="h3 text-gray-2">{{ group.title }}</h3>
          <ul>
            <li class="text-small" *ngFor="let link of group.links">
              <a rel="canonical" routerLink="{{ link.urls[language] }}">{{ 'LANDING.landing.footerLinksPrefix' | translate }} {{ link.text }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</ng-container>

<app-whatsapp-cta></app-whatsapp-cta>
